import ExternalDataStore from "../managers/ExternalDataStore";
import RouteConstants from "../Constants/routes";
import pmWarrantyUtilsConstants from '../Constants/pm-warranty/utils';

export function getPmCompanyData() {
    return ExternalDataStore.getData('pm-company');
}

export function handlePmSessionRedirect() {
    const sessionPmCompanyData = sessionStorage.getItem(pmWarrantyUtilsConstants.sessionKey);
    if(!sessionPmCompanyData) return;
    if(window.location.href.indexOf(RouteConstants.PM_COVERAGE_TYPE) === -1) {
        const parsedObject = JSON.parse(sessionPmCompanyData);
        const queryParams = new URLSearchParams(parsedObject).toString();
        const redirectUrl = `${RouteConstants.PM_COVERAGE_TYPE}?${queryParams}`;
        window.location.replace(redirectUrl);
        return true;
    }
    return false;
}